module.exports = __webpack_public_path__ + "img/logo-footer.da9d5fe7.png";